import { render } from "./VideoModalPopup.vue?vue&type=template&id=1d76bae4&scoped=true&ts=true"
import script from "./VideoModalPopup.vue?vue&type=script&lang=ts"
export * from "./VideoModalPopup.vue?vue&type=script&lang=ts"

import "./VideoModalPopup.vue?vue&type=style&index=0&id=1d76bae4&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d76bae4"]])

export default __exports__